import React from 'react';
import { formatShortDate } from '@odo/shared-ui';
import type { Appointment } from '../../services/appointments';

interface ConfirmCancelModalProps {
    appointment: Appointment;
    isCanceling: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

function firstName(name: string): string {
    if (name.includes(',')) {
        const [, first] = name.split(',');
        return first?.trim() || name;
    }
    return name.split(' ')[0] || name;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
    appointment,
    isCanceling,
    onClose,
    onConfirm
}) => (
    <div
        className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-gray-900/25"
        onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
        <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white shadow-xl">
            <div className="p-6">
                <h2 className="text-base font-semibold text-gray-800">Cancel this appointment?</h2>
                <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                    {firstName(appointment.patientName)}&rsquo;s{' '}
                    {(appointment.reason || 'appointment').toLowerCase()} on{' '}
                    {formatShortDate(appointment.date)} will be removed from the agenda. Linked
                    notes stay on the patient record.
                </p>
                <div className="flex justify-end gap-2 mt-6">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isCanceling}
                        className="rounded-lg border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
                    >
                        Keep it
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isCanceling}
                        className="rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
                    >
                        Cancel appointment
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default ConfirmCancelModal;
